module.exports = __webpack_public_path__ + "img/water-arrow-up-duotone.aa26b42b.svg";